<template>
    <q-page>
        <div class="q-pa-md">
            <div class="text-h4">Días Festivos</div>
            <div class="row">
                <div class="col-md-4">
                    <q-select class="m-3" outlined option-value="value" option-label="option" dense v-model="ejercicio" :options="ejercicios" option-disable="inactive" emit-value map-options label="Ejercicio" @update:model-value="busqueda()"/>
                </div>
            </div>
            <q-table
                dense
                :pagination="{rowsPerPage:25}"
                :rows-per-page-options="[0]"
                virtual-scroll
                flat
                bordered
                :rows="festivos"
                separator="cell">
                    <template v-slot:header>
                        <q-tr class="bg-dark text-white">
                            <q-th key="Descripcion"  align="left">Descripción</q-th>
                            <q-th key="Observaciones"  align="left">Observaciones</q-th>
                            <q-th key="Fecha"  align="left">Fecha</q-th>
                            <q-th key="Actions" align="center" auto-width>   
                                <q-btn icon="add" color="dark" size="sm" padding="5px 5px" @click="editFestivo(0)"/>
                            </q-th>
                        </q-tr>
                    </template>
                    <template v-slot:body="props">
                        <q-tr>
                            <q-td>{{ props.row.Descripcion }}</q-td>
                            <q-td>{{ props.row.Observaciones }}</q-td>
                            <q-td>{{ new Date(props.row.Fecha).toISOString().slice(0,10) }}</q-td>
                            <q-td auto-width>
                                <q-btn-group>
                                    <q-btn icon="edit" color="secondary" size="sm" padding="5px 5px" @click="editFestivo(props.row.IdFestivo)"/>
                                    <q-btn icon="delete" color="negative" size="sm" padding="5px 5px" @click="showFestivo(props.row.IdFestivo)"/>
                                </q-btn-group>
                            </q-td>
                        </q-tr>
                    </template> 
            </q-table>
        </div>
    </q-page>
     <q-dialog v-model="bedit" persistent>
        <q-card style="width: 700px; max-width: 80vw;">
            <q-toolbar class="bg-dark text-white">
            <q-toolbar-title>Día Festivo</q-toolbar-title>
            <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="saveFestivo">
                <q-input class="m-3" :disable="!festivo.Editar" outlined dense v-model="festivo.Descripcion" label="Descripción" :rules="rules"/>
                <q-input class="m-3" :disable="!festivo.Editar" outlined dense v-model="festivo.Fecha" label="Fecha Inicial" mask="date"  :rules="['date']">
                    <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                                <q-date v-model="festivo.Fecha" :locale="myLocale">
                                    <div class="row items-center justify-end">
                                        <q-btn v-close-popup label="Cerrar" color="primary" flat />
                                    </div>
                                </q-date>
                            </q-popup-proxy>
                        </q-icon>
                    </template>
                </q-input>
                <q-input class="m-3" :disable="!festivo.Editar" outlined dense v-model="festivo.Observaciones" label="Observación" type="textarea"  :rules="rules"/>
                <q-toggle class="m-3" :disable="!festivo.Editar" dense v-model="festivo.EsDIaDeMadres" label="Día de las madres" left-label />
                
                <div>
                <div class="q-pa-md q-gutter-sm float-right">
                        <q-btn color="secondary" text-color="white" label="Cerrar" @click="bedit=false"/>
                        <q-btn :disable="!festivo.Editar" color="primary" label="Guardar" type="submit"/>
                    </div>
                </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>
    <q-dialog v-model="bdel" persistent>
        <q-card style="width: 700px; max-width: 80vw;">
            <q-toolbar class="bg-dark text-white">
            <q-toolbar-title>Eliminar Día Festivo</q-toolbar-title>
            <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="delFestivo">
                <q-input class="m-3" disable outlined dense v-model="festivo.Descripcion" label="Descripción" :rules="rules"/>
                <q-input class="m-3" disable outlined dense v-model="festivo.Fecha" label="Fecha Inicial" mask="date"  :rules="['date']">
                    <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                                <q-date v-model="festivo.Fecha" :locale="myLocale">
                                    <div class="row items-center justify-end">
                                        <q-btn v-close-popup label="Cerrar" color="primary" flat />
                                    </div>
                                </q-date>
                            </q-popup-proxy>
                        </q-icon>
                    </template>
                </q-input>
                <q-input class="m-3" disable outlined dense v-model="festivo.Observaciones" label="Observación" type="textarea"  :rules="rules"/>
                <q-toggle class="m-3" disable dense v-model="festivo.EsDIaDeMadres" label="Día de las madres" left-label />
                
                <div>
                <div class="q-pa-md q-gutter-sm float-right">
                        <q-btn color="secondary" text-color="white" label="Cerrar" @click="bdel=false"/>
                        <q-btn color="primary" label="Eliminar" type="submit"/>
                    </div>
                </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import http from "@/services/http"

export default {
    data:()=> ({
        festivos:[],
        festivo:{},
        ejercicios:[],
        ejercicio:0,
        rules: [v => !!v || 'Campo obligatorio',],
        bedit:false,
        bdel:false,
         myLocale: {
        days: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
        daysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
        months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
        monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
        firstDayOfWeek: 1
      },
    }),
    methods:{
        async busqueda(){
            this.festivos = await http.get(`calendario/festivos/${this.ejercicio}`);
        },
        async editFestivo(id){
            if(id===0){
                this.festivo = {IdFestivo:0, Fecha:this.getFecha(new Date()),Descripcion:'', Observaciones:'', EsDIaDeMadres:false, Editar:true}
            }else{
                this.festivo = await http.get(`calendario/festivos/festivo/${id}`)
                this.festivo.Fecha = new Date(this.festivo.Fecha).toISOString().slice(0,10).split('-').join('/')
            }
            this.bedit = true
        },
        getFecha(fecha){
            return fecha.getFullYear()+'/'+String(fecha.getMonth()+1).padStart(2,'0')+'/'+String(fecha.getDate()).padStart(2,'0');
        },
        async saveFestivo(){
            await http.post('calendario/festivos/festivo',this.festivo);
            this.bedit =false
            this.busqueda();
        },
        async showFestivo(id){
            this.festivo = await http.get(`calendario/festivos/festivo/${id}`)
            this.bdel=true
        },
        async delFestivo(){
            await http.delete(`calendario/festivos/delfestivo/${this.festivo.IdFestivo}`)
            this.bdel=false
            this.busqueda();
        }
    },
    created(){
        var fecha = new Date();
        this.ejercicio = fecha.getFullYear();
        var mes = fecha.getMonth()
        var eje = fecha.getFullYear();
        if(mes==11){
            eje = eje+1
        }
        for (var i = 2022; i <= eje; i++) {
            this.ejercicios.push({option:i, value:i})
        }
        this.busqueda();
    }
}
</script>